import React, { useState } from 'react';
import { CardFooter, Form, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import Flex from '../common/Flex';
import Avatar from '../common/Avatar';
import Comments from './Comments';
import { Message, Or, PreloadState, isIterableArray } from '../UI/preloading/PreloadState';
import useSWRFetch from '../../helpers/hooks/useSWRFetch';
import { getAllComment } from '../../helpers/api/feed';
import { useSelector } from 'react-redux';
import ButtonIcon from '../common/ButtonIcon';
import { faComment } from '@fortawesome/free-solid-svg-icons';
import { createComment } from '../../helpers/api/post';
import { SUCCESS_RESPONSE } from '../../helpers/codeResponses/codes';
import { Toast } from '../UI/toast/Toast';
import handleErrorMessage from '../../helpers/errors/handleErrorMessage';

const FeedCardFooter = ({ id, author, profile }) => {
    const [comment, setComment] = useState('');
    const { selectedCondominium } = useSelector(state => state.condominium);
    const [submitting, setSubmitting] = useState(false);

    const {
        data,
        isLoading,
        error,
    } = useSWRFetch(JSON.stringify({ id, selectedCondominium, submitting }), getAllComment);

    const submitComment = e => {
        e.preventDefault();
        setSubmitting(true);
        createComment(id, { condominium: selectedCondominium, comment: comment })
            .then(({ code }) => {
                if (code === SUCCESS_RESPONSE.CREATED) Toast.fire({ type: 'success', title: `Comentario realizado exitosamente.` });
            }).catch(error => handleErrorMessage(error)).finally(() => {
                setSubmitting(false);
                setComment('');
            })
    }

    return <CardFooter className="bg-light pt-0">
        {data?.data.length > 0 && <div className="border-bottom border-200 fs--1 py-3">
            <span className='badge badge-pill badge-default fs--2'>{data?.data.length} Comentario{data?.data.length > 1 && 's'}</span>
        </div>}
        <Flex tag={Form} align="center" className="border-top border-200 pt-3" onSubmit={submitComment}>
            <Avatar src={profile?.data?.image ? `${profile?.data?.image}` : undefined} />
            <InputGroup className='rounded border ml-2'>
                <Input
                    className="fs--1 border-0"
                    placeholder="Escribe un comentario..."
                    type='textarea'
                    required={true}
                    style={{
                        resize: 'none',
                        overflow: 'hidden',
                        minHeight: '20px',
                        outline: 'none',
                        boxShadow: 'none',
                    }}
                    wrap="hard"
                    cols="20"
                    rows='2'
                    value={comment}
                    onChange={({ target }) => {
                        setComment(target.value);
                        target.style.height = 'inherit';
                        target.style.height = `${target.scrollHeight}px`;
                    }}
                />
                <InputGroupAddon addonType="append">
                    <ButtonIcon icon={faComment} className='shadow-none' color='falcon-default' size='sm' disabled={!comment || submitting}>Enviar</ButtonIcon>
                </InputGroupAddon>
            </InputGroup>
        </Flex>
        <PreloadState loadingClass='p-0 mt-3' cond={isIterableArray(data?.data)} loading={isLoading}>
            <Or value={true}>
                <Comments comments={data?.data} />
            </Or>
            <Or value={false} cond={!!error}>
                <Message value={true} icon='info' className='pt-3' fontSize={14}>{error}</Message>
                <Message value={false} icon='info' className='pt-3' fontSize={14}>No hay comentarios</Message>
            </Or>
        </PreloadState>
    </CardFooter>
}

export default FeedCardFooter;